export function localPhonePlaceholder(phonePrefix: string, fallback: string): string {
  const callingCode = phonePrefix.replace(/\D/g, '');
  if (callingCode === '966') return '5XXXXXXXX';
  if (callingCode === '249') return '9XXXXXXXX';
  return fallback;
}

export function normalizePhoneInput(value: string): string {
  return value.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, digit =>
    String(digit.charCodeAt(0) - (digit.charCodeAt(0) >= 0x06f0 ? 0x06f0 : 0x0660)));
}

/** Public sign-in help must use the resolved tenant's published contact. */
export function publishedSupportHref(metadata: unknown): string {
  if (!metadata || typeof metadata !== 'object') return '';
  const meta = metadata as Record<string, unknown>;
  if (typeof meta.tenantId !== 'number' || meta.tenantId <= 0) return '';
  const page = meta.landingPage as { contact?: { email?: unknown; phone?: unknown; whatsAppUrl?: unknown } } | undefined;
  const contact = page?.contact;
  if (!contact) return '';
  if (typeof contact.email === 'string' && /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(contact.email.trim())) return 'mailto:' + contact.email.trim();
  if (typeof contact.phone === 'string' && /^\+?[0-9][0-9 ()-]{5,24}$/.test(contact.phone.trim())) return 'tel:' + contact.phone.trim().replace(/[ ()-]/g, '');
  if (typeof contact.whatsAppUrl === 'string') {
    try { const url = new URL(contact.whatsAppUrl); if (url.protocol === 'https:' && !url.username && !url.password) return url.href; } catch { /* No usable public contact. */ }
  }
  return '';
}
